import fetchSpotFeedHistoryCandles from '@lyra/core/api/fetchSpotFeedHistoryCandles'
import {
  Period,
  SpotFeedHistoryCandlesResponseSchema,
} from '@lyra/core/api/types/public.get_spot_feed_history_candles'
import { tokenConfig, TokenId } from '@lyra/web/constants/tokens'

import { roundToNearest500Seconds } from '../time'

export type SpotPriceCandle = {
  price: number
  timestamp: number
  open: number
  high: number
  low: number
  close: number
}

export const fetchSpotFeedHistoryCandlesData = async (
  currency: string,
  _startTimestamp: number,
  endTimestamp: number,
  period: Period
): Promise<SpotPriceCandle[]> => {
  try {
    const config = tokenConfig[currency as TokenId]
    let startTimestamp = _startTimestamp
    if (config && config.startTimestamp && config.startTimestamp > startTimestamp) {
      startTimestamp = config.startTimestamp
    }
    // Round start and end timestamps to the nearest 500 seconds. Orderbook requested we do this for caching on orderbook reasons.
    const roundedStartTimestamp = roundToNearest500Seconds(startTimestamp)
    const roundedEndTimestamp = roundToNearest500Seconds(endTimestamp)

    const response = await fetchSpotFeedHistoryCandles({
      currency,
      end_timestamp: roundedEndTimestamp,
      period: period as Period,
      start_timestamp: roundedStartTimestamp,
    })
    if ('error' in response) {
      return []
    }
    const spotFeedHistory: SpotPriceCandle[] = response.result.spot_feed_history.map(
      (spotFeedHistory: SpotFeedHistoryCandlesResponseSchema) => {
        return {
          price: +spotFeedHistory.price,
          timestamp: spotFeedHistory.timestamp,
          open: +spotFeedHistory.open_price,
          high: +spotFeedHistory.high_price,
          low: +spotFeedHistory.low_price,
          close: +spotFeedHistory.close_price,
        }
      }
    )
    return spotFeedHistory
  } catch (error) {
    console.error('Error fetching spot history candles:', error)
    return []
  }
}
